import * as React from 'react';
import { Alert } from '@grandvisionhq/common';
import { useFeatureToggles, useIntl } from '@grandvisionhq/state';
import { LocationInfo } from '../components/LocationInfo.js';

const LocationInfoContainer = ({ location: location1 , onEdit , showMessage =true , showOpeningHours  })=>{
    const { isStorePickupPhoneEnabled  } = useFeatureToggles();
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            message: getLabel('checkout.locationInfo.message', {
                hideLabelKey: true
            })
        })
    , [
        getLabel
    ]);
    const isStore = React.useCallback((location)=>'phone' in location
    , []);
    const message = labels.message && showMessage ? /*#__PURE__*/ React.createElement(Alert, {
        icon: "information-circle",
        message: labels.message
    }) : null;
    return /*#__PURE__*/ React.createElement(LocationInfo, {
        isStorePickupPhoneEnabled: isStorePickupPhoneEnabled,
        location: location1,
        message: message,
        onEdit: onEdit,
        showOpeningHours: showOpeningHours,
        isStore: isStore
    });
};

export { LocationInfoContainer };
//# sourceMappingURL=LocationInfoContainer.js.map
